import { createIcon } from '@chakra-ui/icon'

const EmptyFolderGraphic = createIcon({
  viewBox: '0 0 260 200',
  path: (
    <g>
      <defs>
        <style>
          {
            '.cls-5{fill:#87c5f9}.cls-8{fill:#2c93fb}.cls-11{fill:#5f7970}.cls-12{opacity:.28}'
          }
        </style>
      </defs>
      <path
        d="M170.3 27.7c-1 2.4-2.6 4.5-3.6 7-2.6 6.7-17.6 37.4-71.7 36.1-60.8-1.5-95.5 27-89 66.3 10 59.8 116.9 75.1 191.7 39.9 74.8-35.2 64.6-133.9 35.5-156.8C208.5.6 179 7.6 170.3 27.7Z"
        style={{ fill: '#dbf9ed' }}
      />
      <path
        d="M202.48 117.49c3.5 1.9 11.5.4 14-4.4 2.4-4.5 3.1-10 8.4-12.2s14.8-13 14.1-15.4c-1-3.6-11.4-3.2-16.6.2-5.1 3.3-4.6 6.7-8.3 9.3-3.7 2.6-8.5 5.4-11.7 10.1-2.9 4.6.1 12.4.1 12.4Z"
        style={{ fill: '#5fd284' }}
      />
      <path
        d="M202.98 117.69c1.1-1.6 2.6-3.1 4.2-3.8 1.4-.6 2.6-.8 3.9-.9 2.1-.3 3.9-.5 6.4-3.1.3-.3.6-.5.9-.8-.6 1.4-1.1 2.7-1.8 4-2.5 4.6-10 6.2-13.6 4.6Z"
        style={{ fill: '#38c092' }}
      />
      <path
        d="M186.28 142.69c.2.1.4 0 .5-.2.1-.3 13.7-25.6 35.6-48 .1-.2.1-.4 0-.5-.2-.1-.4-.1-.5 0-22 22.5-35.6 47.9-35.7 48.2-.1.2-.1.4.1.5Z"
        className="cls-11"
      />
      <path
        d="M201.98 127.79c-1.6-3.5 2.1-11 5.7-12.5s6.4.1 10.8-4.4c4-4.1 15-4.3 15.6-3.3 1.1 1.9-3.3 10-8.4 11.8-8.2 2.9-8.8 8.3-13.2 10.3-5.6 2.6-10.5-1.9-10.5-1.9Z"
        style={{ fill: '#f9cc7d' }}
      />
      <path
        d="M188.28 143.89c.2.1.4 0 .5-.1 8.7-14.8 28-26.5 28.1-26.6.2-.1.2-.3.1-.5s-.3-.2-.5-.1-19.6 11.9-28.4 26.9c-.1 0 0 .2.2.4Z"
        className="cls-11"
      />
      <path
        d="M182.32 50.95h-76.6l-12.8-8.3h-35.2c-6 0-10.9 5-10.7 11l1.2 40.9h144.8v-32.9c0-5.9-4.8-10.7-10.7-10.7Z"
        className="cls-8"
      />
      <path d="M62.12 126.35h124.8v-66.6l-124.8-.1v66.7z" className="cls-8" />
      <path d="M57.52 130.95h124.2v-66.6l-124.2-.1v66.7z" className="cls-8" />
      <path
        d="M191.72 76.35H50.42c-4.4 0-7.8 3.8-7.3 8l10.1 77.4c.5 3.6 3.6 6.2 7.3 6.2h120.6c3.7 0 6.8-2.6 7.3-6.2l10.6-77.4c.5-4.2-2.9-8-7.3-8Z"
        style={{ fill: '#027df9' }}
      />
      <path
        d="M191.42 78.45H50.22c-4.4 0-7.8 3.8-7.3 8l10.1 77.4c.5 3.6 3.6 6.2 7.3 6.2h120.6c3.7 0 6.8-2.6 7.3-6.2l.7-5.1 9.9-72.3c.5-4.2-2.9-8-7.4-8Z"
        style={{ fill: '#5ba8f8' }}
      />
      <g className="cls-12">
        <path
          d="M191.42 78.45h-91.8l91.5 63.1 7.6-55.1c.6-4.2-2.8-8-7.3-8Z"
          className="cls-5"
        />
      </g>
      <g className="cls-12">
        <path
          d="m51.12 78.45 114.1 91.6h15.6c3.7 0 6.8-2.6 7.3-6.2l.7-5.1-116-80.3h-21.7Z"
          className="cls-5"
        />
      </g>
      <circle cx="120.98" cy="127.83" r="23.81" style={{ fill: '#fff' }} />
      <path
        d="m118.35 131.39-1.16-12.88v-1.26h7.57v1.26l-1.19 12.88h-5.21Zm-.25 7.02v-4.15h5.72v4.15h-5.72Z"
        style={{
          fill: '#5ba8f8',
          stroke: '#5ba8f8',
          strokeWidth: 0.75,
          strokeMiterlimit: 10,
        }}
      />
    </g>
  ),
})

export default EmptyFolderGraphic
